import AppLayout from '../../layouts/AppLayout/AppLayout';
import MainHeader from '../../Components/MainHeader/MainHeader';
import MainFooter from '../../Components/MainFooter/MainFooter';
import ActivateUser from '../../Components/Auth/ActivateUser/ActivateUser';

function ActivateUserPage() {
    return (
        <AppLayout>
            <MainHeader variant="cabinet" />
            <main>
                <ActivateUser />
            </main>
            <MainFooter />
        </AppLayout>
    );
}

export default ActivateUserPage;
